import { render, staticRenderFns } from "./ComponentAlertPageProfile.vue?vue&type=template&id=7f00ebe6"
import script from "./ComponentAlertPageProfile.vue?vue&type=script&lang=js"
export * from "./ComponentAlertPageProfile.vue?vue&type=script&lang=js"
import style0 from "./ComponentAlertPageProfile.vue?vue&type=style&index=0&id=7f00ebe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports